import { fetchWidgetsData } from "@/lib/axios/api/widgets.api";
import { FetchWidgetsParams, WidgetsApiResponse } from "@/lib/axios/types/widgets.type";
import { useEffect, useState } from "react";

export function useWidgetsData(params?: Partial<FetchWidgetsParams>) {
  const [data, setData] = useState<WidgetsApiResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    setLoading(true);
    const payload: Partial<FetchWidgetsParams> = {
      ...(params || {})
    };
    fetchWidgetsData(payload as FetchWidgetsParams, { signal: controller.signal })
      .then((res) => {
        if (isMounted) {
          setData(res);
          setError(null);
        }
      })
      .catch((err) => {
        if (isMounted) {
          if (err?.name === 'CanceledError' || err?.name === 'AbortError') return;
          setError(err.message || "Failed to fetch data");
        }
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [
    params?.startDate,
    params?.endDate,
    JSON.stringify(params?.queueMicrosoftIds),
    JSON.stringify(params?.agentMicrosoftIds),
    JSON.stringify(params?.widgetIds),
    JSON.stringify(params?.widgetSort),
    params?.callId,
    JSON.stringify(params?.groupIds),
    params?.timeStamp
  ]);

  return { data, loading, error, trendsInsightsData: data?.trendsInsightsData };
}
